import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "2 1 20 20",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 10,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.354 15.752l-3.183 3.182c-1.171 1.172-3.071 1.172-4.243 0l-.707-.706c-1.171-1.171-1.171-3.071 0-4.242l4.597-4.597c1.172-1.172 3.071-1.172 4.243 0l.707.707M11.647 6.559l3.182-3.181c1.172-1.171 3.07-1.171 4.242 0l.707.707c1.172 1.171 1.172 3.071 0 4.242l-4.596 4.597c-1.172 1.172-3.071 1.172-4.242 0" })
});
export default SvgLink;
